import App from './App';
import './styles.css'; // This line makes Webpack bundle your CSS
document.addEventListener('DOMContentLoaded', () => {
    const root = document.getElementById('app');
    if (!root) {
        console.error('Root container element not found!');
        return;
    }
    new App(root);
});
